<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
.staff-service-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
}

.staff-info {
    min-width: 0;
    padding-right: 12px;
}

.staff-info h6 {
    margin: 0 0 5px;
    font-size: 15px;
    font-weight: 600;
    color: #343a40;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.staff-info span {
    font-size: 12px;
    color: #6c757d;
}

/* Service counter */

.staff-services {
    width: 58px;
    height: 58px;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
    color: #fff;
}

.staff-services strong {
    font-size: 17px;
    font-weight: 700;
    line-height: 18px;
}

.staff-services small {
    font-size: 8px;
    text-transform: uppercase;
    line-height: 10px;
}


/* Success */

.success-card {
    border-left: 3px solid #198754;
}

.success-card .staff-services {
    background: #198754;
}


/* Primary */

.primary-card {
    border-left: 3px solid #0d6efd;
}

.primary-card .staff-services {
    background: #0d6efd;
}


/* Warning */

.warning-card {
    border-left: 3px solid #ffc107;
}

.warning-card .staff-services {
    background: #ffc107;
    color: #212529;
}


/* Danger */

.danger-card {
    border-left: 3px solid #dc3545;
}

.danger-card .staff-services {
    background: #dc3545;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Parcels Services Report</h3>
                    <span></span>
                   </div>
                </div>
            </div>
        </div>

      <div class="row">

    <!-- Success -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card success-card">

            <div class="staff-info">
               <h6>Served Parcel</h6>
                <p class="text-success">Today's </p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.todays }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Primary -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card primary-card">

            <div class="staff-info">
                <h6>Served Parcel</h6>
                <p class="text-primary">Last 7Day's</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.day7 }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Warning -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card warning-card">

            <div class="staff-info">
               <h6>Served Parcel</h6>
                <p class="text-warning">Last 30 Day's</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.day30 }}</strong>
                <small>Services</small>
            </div>

        </div>
    </div>

    <!-- Danger -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <!--div class="staff-service-card danger-card">

            <div class="staff-info">
              <h6>{{ dataz.low_week.fulname }}</h6>
                <span>{{ dataz.low_week.username }}</span>
                <p class="text-danger">Low of Weak</p>
            </div>

            <div class="staff-services">
                <strong>{{ dataz.low_week.servs }}</strong>
                <small>Services</small>
            </div>

        </div-->
    </div>

</div>

        <div class="row">
            <div class="col-12">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.filter_parcel"
                                                class="form-control"
                                                placeholder="Search to filter">
                        </div>
                        
                           <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid"></div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterParcels" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                         
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Parcel Name</th>
                                <th>Price</th>
                                <th> Receiver  </th>
                                <th  v-if="user.role == 4"> Sender </th>
                                <th> From - To </th>
                                <th  v-if="user.role < 4"> Served By </th>
                                <th> Sent - Served </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.tag_name }}</span>
                                </td>
                                <td><label class="badge badge-dark"><PriceFormat :Price="parcel.price"/></label></td>
                                <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.receiver_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.receiver_phone }}</span>
                                </td>
                                <td  v-if="user.role == 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.sender_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.sender_phone }}</span>
                                </td>
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.branch_from_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.branch_to_name }}</span>
                                </td>
                               <td  v-if="user.role < 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.fulname }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.phone1 }}</span>
                                </td>
                                <td class="text-capitalize">
                                    <span class="d-block"><DateFormat :Date_="parcel.sent_at"/></span>
                                    <span class="d-block mt-1 text-muted"><DateFormat :Date_="parcel.created_at"/></span>
                                </td>
            
                                <td>
                                    <label v-if="parcel.type == 0" class="badge badge-info">Picked</label>
                                    <label v-if="parcel.type == 1" class="badge badge-warning">Hapokei</label>
                                    <label v-if="parcel.type == 2" class="badge badge-danger">Hapatikani</label>
                                     <label v-if="parcel.type == 3" class="badge badge-primary">Kapokea</label>
                                    <label v-if="parcel.type == 4" class="badge badge-success">Completed</label>
                                    <span class="m-1"></span>
                                    <button type="button" @click="getReceiveParcel(parcel)"
                                        class="_btn btn receive_btn btn-primary">
                                        {{ parcel.events }} Events
                                    </button>
                                </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                    </div>

                    <div v-if="user.role == 4" class="row">
            <div class="col-12">

                <h4 class="py-4">Staff Details & Branches </h4>

                <div class="card-body">

                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-8 col-12">

                            <div class="row">

                                <!-- Staff Information -->
                                <div class="col-sm-12 col-md-6 mb-4">

                                    <div class="staff-card">

                                        <!-- Avatar -->
                                        <div class="staff-avatar-wrapper">
                                            <img :src="$store.state.img_url + user.avator" alt="Staff Avatar"
                                                class="staff-avatar">
                                        </div>

                                        <!-- Staff Details -->
                                        <div class="staff-info">

                                            <h5 class="staff-name text-capitalize">
                                                {{ staff.fulname }}
                                            </h5>

                                            <div class="staff-detail">
                                                <span>Username :</span>
                                                <span><b class="">{{ staff.username }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <span>Phone no :</span>
                                                <span><b class="text-capitalize">{{ staff.phone1 }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <span>Branch :</span>
                                                <span><b class="text-capitalize">{{ staff.branch_name }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <i class="fa fa-code-branch"></i>
                                                <span>
                                                    <b>{{ this.staff_branches.length }}</b> Assigned Branches
                                                </span>
                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <!-- Branches -->
                                <div class="col-sm-12 col-md-6 mb-4">

                                    <div class="branch-table">

                                        <h5 class="mb-1 pt-3 mx-3">
                                            Assigned Branches
                                        </h5>

                                        <div class="table-responsive">

                                            <table class="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Branch Name</th>
                                                       
                                                    </tr>
                                                </thead>

                                                <tbody id="staff-list">

                                                    <tr v-for="(branch, index) in staff_branches" :key="branch.id">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>

                                                        <td>
                                                            {{ branch.name }}
                                                        </td>

                                                     
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                        <div class="col-sm-12 col-md-4 col-12">

                        </div>
                    </div>
                </div>
            </div>
        </div>
               
            </div>
        </div>
    </div>

     <!--receiver -->
    <div class="modal fade mobile-full-width" id="receiveModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="receiveModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Parcel Service Events</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="row">
                       
                        <div class="col-sm-12">
                            <h4 class="text-center mt-3">{{ parcel.name }}</h4>
                            <h5 id="">Sender : {{ parcel.sender_name }} - {{ parcel.sender_phone }}</h5>
                            <h5 id="">Receiver : {{ parcel.receiver_name }} - {{ parcel.receiver_phone }}</h5>
                        </div>
                        

                        <div class="col-sm-12 col-md-12">
                            <div>
                                  <div class="table-responsive">
                                <span class="m-1"></span>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th> Client </th>
                                            <th> Status </th>
                                            <th> Date Time </th>
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(event, index) in events" :key="event.id"
                                            id="event_{{this.id}}">
                                            <td>{{ index + 1 }}</td>
                                            <td> {{ event.client }}</td>
                                            <td>
                                                <label v-if="event.type == 1" class="badge badge-warning">Hapokei</label>
                                                <label v-if="event.type == 2" class="badge badge-danger">Hapatikani</label>
                                                <label v-if="event.type == 3" class="badge badge-primary">Kapokea</label>
                                                <label v-if="event.type == 4" class="badge badge-success">Completed</label>
                                            </td>
                                            <td>
                                                {{ event.created_at }}
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            </div>

                             <div v-if="loading_event" class="mt-1">
                                <div class="text-center">
                                    <div class="spinner-grow text-success" role="status"></div>
                                    <div class="spinner-grow text-danger" role="status"></div>
                                    <div class="spinner-grow text-warning" role="status"></div>
                                </div>
                            </div>

                            <div v-if="user.role == 4">

                             <div class="form-group mt-3">
                                <label class="form-label">Select Client</label>
                                <select class="form-control" style="height: 50px;" v-model="client">
                                    <option value="receiver">Receiver</option>
                                    <option value="receiver">Sender</option>
                                </select>
                            </div>

                           <div class="d-flex">
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(2)" class="btn btn-danger m-1">Hapatikani</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(1)" class="btn btn-warning m-1">Hapokei</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(3)" class="btn btn-primary m-1">Kapokea</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(4)" class="btn btn-success m-1">Completed</button>
                           </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_event:false,
            search_staff:"",
            filter_parcel:"",
            heading:"To Days Serviced Parcels Reports",
            parcels:[],
            og_parcels:[],
            dataz:{
               todays:0,
               day7:0,
               day30:0
            },
            events:[],
            parcel:{},
            client:"receiver",
            fdate:"",
            tdate:"",
            staff_branches: [],
            staff: {},
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

         getReceiveParcel(parcel) {

            this.parcel = parcel

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiveModal")
            );

            modal.show();

            var service_id = parcel.id

            this.getEventStatus(service_id)
        },

        async updateEventStatus(type){

          this.loading_event = true

          var service_id = this.parcel.id
          var client = this.client

          var created_at =  this.getCurrentDateTime()

          var response = await axios
              .post(this.$store.state.api_url + "/service/update-event", {service_id, client, type})
              .catch((errors) => {
                    this.loading_event = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading_event = false

               this.updateParcel(service_id, type)

               this.events = [{id:service_id, created_at, type, client},...this.events]

          } else {
                this.loading_event = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },
           async getEventStatus(service_id){

          this.loading_event = true

          var response = await axios
              .post(this.$store.state.api_url + "/service/get-event", {service_id})
              .catch((errors) => {
                    this.loading_event = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading_event = false
               this.events = response.data.events

          } else {
                this.loading_event = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        async getParcels() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/service/served-parcels")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels
                this.dataz = response.data.dataz

                this.staff_branches = response.data.staff_branches
                this.staff = response.data.staff

               console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async filterParcels(){

             this.loading = true
          var fdate = this.fdate
          var tdate = this.tdate

           var admin = 0
         var staff_id = 0

          var response = await axios
              .post(this.$store.state.api_url + "/service/filter-served-parcels", {fdate, tdate, staff_id, admin})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels
               
                this.heading = "Services Reports From ("+fdate+" To "+tdate+")"
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },
        updateParcel(id, type) {
    const parcel = this.parcels.find(item => item.id == id);

    if (parcel) {
        parcel.type = type;
        parcel.events = (parcel.events || 0) + 1;
    }
},
         getCurrentDateTime() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");

            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

        filter_parcel(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.parcels = this.og_parcels
                return
            }

            this.parcels = this.og_parcels.filter(parcel => {

                return (
                    (parcel.name && parcel.name.toLowerCase().includes(term)) ||
                    (parcel.price && parcel.price.toLowerCase().includes(term)) ||
                    (parcel.sender_name && parcel.sender_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_name && parcel.receiver_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_phone && parcel.receiver_phone.toLowerCase().includes(term)) ||
                    (parcel.sender_phone && parcel.sender_phone.toLowerCase().includes(term)) ||
                    (parcel.tag_name && parcel.tag_name.toLowerCase().includes(term)) ||
                    (parcel.branch_from_name && parcel.branch_from_name.toLowerCase().includes(term))  ||
                    (parcel.branch_to_name && parcel.branch_to_name.toLowerCase().includes(term)) 
                )
            })
        },
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getParcels()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
